/*
  * Homepage
  * Contains :
  * - animation on industries cards
  *
*/

import * as basicScroll from 'basicscroll'

const movingCases = document.querySelectorAll('.js-moving-cases');
if (movingCases.length && window.innerWidth >= 1024) {
  movingCases.forEach((elem) => {
    const instance = basicScroll.create({
      elem: elem,
      from: 'top-bottom',
      to: 'middle-top',
      direct: document.querySelector('.home-industries'),
      props: {
        '--translateY': {
          from: '0px',
          to: '-100px',
        }
      }
    })

    instance.start()
  })
}

const movingTechCols = document.querySelectorAll('.js-tech-col');
if (movingTechCols.length && window.innerWidth >= 768) {
  const instance = basicScroll.create({
    elem: movingTechCols[0],
    from: 'top-bottom',
    to: 'middle-top',
    direct: document.querySelector('.home-tech'),
    props: {
      '--slowY': {
        from: '0px',
        to: '-72px',
      }
    }
  });

  instance.start()
}

const fasterMovingTechCols = document.querySelectorAll('.js-tech-col2');
if (fasterMovingTechCols.length && window.innerWidth >= 768) {
  const instance = basicScroll.create({
    elem: fasterMovingTechCols[0],
    from: 'top-bottom',
    to: 'middle-top',
    direct: document.querySelector('.home-tech'),
    props: {
      '--fastY': {
        from: '0px',
        to: '-144px',
      }
    }
  })

  instance.start();
}
